import { motion, useReducedMotion, type HTMLMotionProps } from "framer-motion";
import { cn } from "@/lib/cn";

export type SurfaceCardProps = HTMLMotionProps<"div"> & {
  inset?: boolean;
};

export function SurfaceCard({
  className,
  inset = false,
  whileHover,
  whileTap,
  transition,
  ...props
}: SurfaceCardProps) {
  const reduceMotion = useReducedMotion();
  return (
    <motion.div
      whileHover={
        reduceMotion ? undefined : (whileHover ?? { y: -2 })
      }
      whileTap={
        reduceMotion ? undefined : (whileTap ?? { scale: 0.995 })
      }
      transition={transition ?? { type: "spring", stiffness: 360, damping: 34 }}
      className={cn(
        "rounded-2xl border border-border/10 bg-panel/10 shadow-glow",
        "transition-colors hover:border-accent2/18 hover:bg-panel/14",
        inset ? "shadow-[0_0_0_1px_rgb(var(--border)_/_0.06)_inset]" : "",
        className
      )}
      {...props}
    />
  );
}

